"use client";

import { ArrowRight, Timer } from "lucide-react";
import type { CSSProperties } from "react";

import { useCcLatchInView } from "@/lib/use-cc-latch-in-view";
import type { SeoWorkflowScaleCardCopy } from "./seo-workflow-copy";
import { CcSeoWorkflowCard } from "./CcSeoWorkflowCard";

type CcSeoWorkflowScaleProps = {
  copy: SeoWorkflowScaleCardCopy;
};

export function CcSeoWorkflowScale({ copy }: CcSeoWorkflowScaleProps) {
  const { ref: surfaceRef, isInView } = useCcLatchInView<HTMLDivElement>({
    threshold: 0.35,
  });

  return (
    <CcSeoWorkflowCard
      id="scale"
      title={copy.title}
      description={copy.description}
      badge={copy.badge}
      icon={Timer}
    >
      <div className="cc-seo-workflow-scale">
        <div
          ref={surfaceRef}
          className={[
            "cc-seo-workflow-scale__surface",
            isInView && "cc-seo-workflow-scale__surface--in-view",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          <div className="cc-seo-workflow-scale__header">
            <span className="cc-seo-workflow-scale__icon" aria-hidden="true">
              <Timer className="cc-seo-workflow-scale__header-icon" size={28} strokeWidth={1.5} />
            </span>
            <span className="cc-seo-workflow-scale__realtime">{copy.realtime}</span>
          </div>

          <ul className="cc-seo-workflow-scale__rows">
            {copy.metrics.map((metric, index) => (
              <li
                key={metric.label}
                className="cc-seo-workflow-scale__row"
                style={{ "--scale-row-index": index } as CSSProperties}
              >
                <span className="cc-seo-workflow-scale__row-label">{metric.label}</span>
                <span className="cc-seo-workflow-scale__row-values">
                  <span className="cc-seo-workflow-scale__value-before">{metric.before}</span>
                  <ArrowRight
                    className="cc-seo-workflow-scale__arrow"
                    size={14}
                    strokeWidth={1.5}
                    aria-hidden
                  />
                  <span className="cc-seo-workflow-scale__value-after">{metric.after}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </CcSeoWorkflowCard>
  );
}
